import React from 'react';
import PropTypes from 'prop-types';
import { AddInventoryPopover } from '../pop-overs/add-inventory';
import { SubtractInventoryPopover } from '../pop-overs/subtract-inventory';
import { SetInventoryPopover } from '../pop-overs/set-product-inventory';
import style from '../style.module.less';

export const InventoryAdjustment = ({ inventoryLocationId, onReloadLocations, productId, stock }) => {
  return (
    <div className={style['inventory-adjustment']}>
      <AddInventoryPopover inventoryLocationId={inventoryLocationId} onReloadLocations={onReloadLocations} productId={productId} />
      <SubtractInventoryPopover inventoryLocationId={inventoryLocationId} productId={productId} />
      <SetInventoryPopover
        inventoryLocationId={inventoryLocationId}
        onReloadLocations={onReloadLocations}
        productId={productId}
        stock={stock}
      />
    </div>
  );
};

InventoryAdjustment.propTypes = {
  inventoryLocationId: PropTypes.string.isRequired,
  onReloadLocations: PropTypes.func.isRequired,
  productId: PropTypes.string.isRequired,
  stock: PropTypes.number.isRequired,
};
